<template lang="pug">
  .component-backoffice-translation.row.column
    GroupedTranslation(:translations="overridenTranslations")
      h3 Overriden translations
    GroupedTranslation(:translations="errorMessages")
      h3 Overridable translations
</template>

<script type="text/babel">
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import BaseList from './BaseList'
import collect from "collect.js";
import {mapState} from "vuex";
import TranslationEdit from "./TranslationEdit.vue";
import GroupedTranslation from "./GroupedTranslation.vue";


export default {
  name: 'TranslationList',
  components: {
    GroupedTranslation,
    TranslationEdit,
    BaseList,
  },
  data: function () {
    return {
      component: require('src/components/backoffice/Translation.vue'),
      translation: [],
      overridenTranslations: {},
      errorMessages: {},
      selected: {}
    }
  },
  created() {
    this.loadOverriden()
    this.loadErrorMessages()
  },
  methods: {
    loadOverriden() {
      KeplerBackofficeSdk.translations.list.all(1, -1, (data) => {
        this.overridenTranslations = collect(data.items).groupBy('group').all()
      })
    },
    loadErrorMessages() {
      KeplerBackofficeSdk.translations.list.overridable(['exception','exceptions','flows','hardware','paymentmethods','profile','reservation','reservations','results','subscription','rate_descriptor'], (data) => {
        this.errorMessages = collect(data).groupBy('group').all()
      })
    }
  },
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
    allowedLanguages() {
      return collect(this.configuration.system.system_fields_configuration.value).first((i) => i.field === 'allowedLanguages').config.split(',')
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TranslationList.vue?4c8a9778